import { useMutation, useQueryClient } from 'react-query'
import { QUERY_KEYS } from 'src/constants'
import { languagesService } from 'src/services/languages.service'
import { IUpdateTranslationSwitchDto } from 'src/types'

export const useUpdateTranslationSwitch = () => {
  const queryClient = useQueryClient()
  return useMutation(
    (dto: IUpdateTranslationSwitchDto) => languagesService.updateLanguageTranslationSwitch(dto),
    {
      onSuccess: (data) => {
        if (!data) return

        queryClient.invalidateQueries(QUERY_KEYS.TRANSLATIONS)
        queryClient.invalidateQueries(QUERY_KEYS.TRANSLATION_HELPER_TEXT_STATUS)
      },
    },
  )
}
